const HTML_CLASS = 'pc-rem-adapt'
const BASE_WIDTH = 1920
const BASE_FONT_SIZE = 16
const MIN_FONT_SIZE = (1280 / BASE_WIDTH) * BASE_FONT_SIZE
const MAX_FONT_SIZE = BASE_FONT_SIZE

function getFontSize() {
  const width = document.documentElement.clientWidth || BASE_WIDTH
  const size = (width / BASE_WIDTH) * BASE_FONT_SIZE
  return Math.min(MAX_FONT_SIZE, Math.max(MIN_FONT_SIZE, size))
}

export function setFlexibleRem() {
  document.documentElement.style.fontSize = `${getFontSize()}px`
  document.documentElement.classList.add(HTML_CLASS)
}

export function resetFlexibleRem() {
  document.documentElement.style.fontSize = ''
  document.documentElement.classList.remove(HTML_CLASS)
}

export function bindFlexibleRem() {
  setFlexibleRem()
  window.addEventListener('resize', setFlexibleRem, { passive: true })
}

export function unbindFlexibleRem() {
  window.removeEventListener('resize', setFlexibleRem)
  resetFlexibleRem()
}
